export function ReactGfg(){

    // This for the 1st Part of the JS Links Bro 
    
    const val1 = "https://www.geeksforgeeks.org/javascript/?ref=lbp ";
    const val2 = " https://www.geeksforgeeks.org/javascript-comments/?ref=lbp";
    const val3 = " https://www.geeksforgeeks.org/variables-datatypes-javascript/?ref=lbp";
    const val4 = " https://www.geeksforgeeks.org/javascript-let/?ref=lbp";
    const val5 = "https://www.geeksforgeeks.org/javascript-var/?ref=lbp ";
    const val6 = "https://www.geeksforgeeks.org/javascript-const/?ref=lbp ";
    const val7 = "https://www.geeksforgeeks.org/javascript-operators/?ref=lbp ";
    const val8 = "https://www.geeksforgeeks.org/javascript-statements/?ref=lbp";
    const val9 = "https://www.geeksforgeeks.org/javascript-if-else/?ref=lbp ";
    const val10 = " https://www.geeksforgeeks.org/switch-case-in-javascript/?ref=lbp";
    const val11= " https://www.geeksforgeeks.org/javascript-break-statement/?ref=lbp";
    const val12 = " https://www.geeksforgeeks.org/javascript-continue-statement/?ref=lbp";
    const val13 = " https://www.geeksforgeeks.org/javascript-return-statement/?ref=lbp";
    
    // This for the 2nd Part of the JS Links Bro 
    
    const val1_1= " https://www.geeksforgeeks.org/loops-in-javascript/?ref=lbp";
    const val1_2= "https://www.geeksforgeeks.org/objects-in-javascript/?ref=lbp ";
    const val1_3= " https://www.geeksforgeeks.org/functions-in-javascript/?ref=lbp";
    const val1_4= " https://www.geeksforgeeks.org/javascript-arrays/?ref=lbp";
    const val1_5= " https://www.geeksforgeeks.org/javascript-strings/?ref=lbp";
    const val1_6= " https://www.geeksforgeeks.org/javascript-numbers/?ref=lbp";
    const val1_7= " https://www.geeksforgeeks.org/javascript-map/?ref=lbp";
    const val1_8= "https://www.geeksforgeeks.org/dom-document-object-model/ ";
    const val1_9= "https://www.geeksforgeeks.org/async-await-function-in-javascript/ ";
    
    
        return(
    
            <>
    
                    
            <h1 className="html_gfg_heading">These are the <strong style={{textDecoration : 'underline', color : 'blue'}}>Top 8</strong> recommended Geeks for Geeks links that you can refer with important Topics </h1>
    
    
            <h4 className="des_co_html">
    
            1. Dive Into The<strong> Main </strong>Concepts <br/>
            2. Enough Concepts to learn & Understand  <br/>
            3. Only important Concepts to learn through every topics
            </h4>
    
            {/* <-----------------------------------------1------------------------------------------*/}
            <div className="container_html_gfg_links">
    
            <p className="vid">1. (Part-1 ) Intro To JavaScript ( Basics)
    
    
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val1, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------2------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 2. (Part-2) Comments
    
    
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val2, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------3------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 3. (Part-3) DataTypes
    
    
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val3, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------4------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 4. (Part-4) Let
    
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val4, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div> 
    
    
            {/* <-----------------------------------------5------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 5. (Part-5)Var
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val5, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------6------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 6. (Part-6)Const
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val6, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------7------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 7. (Part-7) Operators
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val7, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------8------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 8. (Part-8)Statements
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val8, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------9------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 9. (Part-9) if-else
    
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val9, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
            {/* <-----------------------------------------10------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 10. (Part-10) switch
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val10, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
            {/* <-----------------------------------------11------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 11. (Part-11) Break
    
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val11, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
            {/* <-----------------------------------------12------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 12. (Part-12) Continue
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val12, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
            {/* <-----------------------------------------13------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 13. (Part-13) Return 
            
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val13, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            <h3 style={{fontFamily : 'cursive'}}> (Part - 2 ) Main Concepts ( Medium )
            </h3>
    
            {/* <-----------------------------------------1.1------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 1.1 . (Part-1.1) Loops , for, while , do-while, for each etc…
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_1, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------1.2------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 1.2 . (Part-1.2) Objects , Structure Destructure 
    
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_2, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
            {/* <-----------------------------------------1.3------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 1.3 . (Part-1.3) Functions , Arrow Functions 
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_3, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
    
            {/* <-----------------------------------------1.4------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 1.4 . (Part-1.4) Arrays
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_4, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
    
            {/* <-----------------------------------------1.5------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 1.5 . (Part-1.5) Strings
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_5, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
    
            {/* <-----------------------------------------1.6------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 1.6 (Part-1.6) Numbers
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_6, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
    
            {/* <-----------------------------------------1.7------------------------------------------*/}
    
            <div className="container_html_gfg_links">
    
            <p className="vid"> 1.7 . (Part-1.7) Map
    
            <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_7, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
             {/* <-----------------------------------------1.8------------------------------------------*/}
    
             <div className="container_html_gfg_links">
    
        <p className="vid"> 1.8 (Part-1.8) DOM #Important_Don't_Neglect 
    
        <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_8, "_blank")}>  Click Me </button>  
    
            </p>
            <p>
            </p>
    
            </div>
    
                {/* <-----------------------------------------1.9------------------------------------------*/}
    
             <div className="container_html_gfg_links">
    
            <p className="vid"> 1.9 (Part-1.9) Async & Await 
    
    
        <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}}        onClick={() => window.open(val1_9, "_blank")}>  Click Me </button>  
    
        </p>
        <p>
        </p>
    
        </div>
    
            </>
        )
    }
    
    export default ReactGfg; 